import { TypographyProps } from 'styled-typography';

export const typography: Partial<TypographyProps> = {
  fontSizes: ['2.369rem', '1.777rem', '1.333rem', '1rem', '0.75rem', '10px'],
  bodyFontFamily: 'Roboto, sans-serif',
  headingFontFamily: 'Roboto, sans-serif',
};
